import { render, staticRenderFns } from "./cart-footer.vue?vue&type=template&id=5816704b&scoped=true&lang=pug&"
import script from "./cart-footer.vue?vue&type=script&lang=coffee&"
export * from "./cart-footer.vue?vue&type=script&lang=coffee&"
import style0 from "./cart-footer.vue?vue&type=style&index=0&id=5816704b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816704b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default})
